<template>
  <div class="container-xl">
    <Card
      title="White Labels"
      subtitle="Listagem dos clientes, somente disponível para administradores"
    >
      <table class="table table-sm table-hover table-striped">
        <thead>
          <tr>
            <PkHeader/>
            <EditHeader/>
            <DeleteHeader/>
            <StatusHeader/>
            <th data-column-id="name">Nome</th>
          </tr>
        </thead>
      </table>

    </Card>
  </div>
</template>

<script>
import $ from 'jquery'
import { initGrid } from 'hennig-common'
import PkHeader from '@/components/grid/PkHeader'
import EditHeader from '@/components/grid/EditHeader'
import DeleteHeader from '@/components/grid/DeleteHeader'
import StatusHeader from '@/components/grid/StatusHeader'
import PageHeader from '@/components/PageHeader'
import Card from '@/components/Card'

export default {
  name: 'WhiteLabels',
  components: {
    Card,
    StatusHeader,
    DeleteHeader,
    EditHeader,
    PkHeader
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const that = this
      const addLabel = 'Novo'
      const collectionObj = 'WhiteLabel'
      initGrid({
        container: $(this.$el).find('table'),
        collectionObj,
        modalAdd: true,
        modalEdit: true,
        addLabel,
        confirmationMethod: (cb) => {
          this.dialogs()
            .Confirmation
            .show({ text: 'Deseja realmente excluir este White Label?' }, cb)
        }
      })
    }
  }
}
</script>
